import React from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core'
import { Button } from '@material-ui/core'

type LeaveFolderDialogProps = {
  open: boolean
  onClose: () => void
}

const LabelTypography = styled(Typography)`
  color: #9e9e9e;
`
const FolderNameTypography = styled(Typography)`
  margin-bottom: 16px;
`

const LeaveFolderDialog: React.FC<LeaveFolderDialogProps> = ({open, onClose}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>このフォルダから抜けますか？</DialogTitle>
      <DialogContent style={{overflow: 'hidden'}}>
        <LabelTypography variant="caption">フォルダ名</LabelTypography>
        <FolderNameTypography variant="h6">参加中１</FolderNameTypography>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>
          キャンセル
        </Button>
        <Button color='primary' onClick={onClose}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LeaveFolderDialog;
